import React from 'react'
import { Security, Bell, Info, Support, Globe, Money } from '@/assets/icons'

export interface SettingAction {
  id: number
  titleKey: string
  descriptionKey: string
  icon: React.ComponentType<{ size?: number; color?: string }>
  route?: string
  link?: string
  iconColor?: string
  iconBgColor?: string
}

const settings: Omit<SettingAction, 'id'>[] = [
  {
    titleKey: 'screens:profile.profileSettings.items.paymentCurrency.title',
    descriptionKey:
      'screens:profile.profileSettings.items.paymentCurrency.description',
    icon: Money,
    route: '/choose-payment-currency',
    iconColor: '#FFFFFF',
    // iconBgColor: '#F59E0B',
  },
  {
    titleKey: 'screens:profile.profileSettings.items.notifications.title',
    descriptionKey:
      'screens:profile.profileSettings.items.notifications.description',
    icon: Bell,
    route: '/notifications-settings',
    iconColor: '#FFFFFF',
    // iconBgColor: '#4EF6EC',
  },
  {
    titleKey: 'screens:profile.profileSettings.items.security.title',
    descriptionKey:
      'screens:profile.profileSettings.items.security.description',
    icon: Security,
    route: '/security',
    iconColor: '#FFFFFF',
    // iconBgColor: '#6366F1',
  },
  {
    titleKey: 'screens:profile.profileSettings.items.language.title',
    descriptionKey:
      'screens:profile.profileSettings.items.language.description',
    icon: Globe,
    route: '/choose-language',
    iconColor: '#FFFFFF',
    // iconBgColor: '#10B981',
  },
  {
    titleKey: 'screens:profile.profileSettings.items.questions.title',
    descriptionKey:
      'screens:profile.profileSettings.items.questions.description',
    icon: Info,
    route: '/faqs',
    iconColor: '#FFFFFF',
    // iconBgColor: '#F59E0B',
  },
  {
    titleKey: 'screens:profile.profileSettings.items.support.title',
    descriptionKey: 'screens:profile.profileSettings.items.support.description',
    icon: Support,
    link: 'https://kemapp.io/frequently-asked-questions/support',
    iconColor: '#FFFFFF',
    // iconBgColor: '#10B981',
  },
]

export const settingsActions = settings.map((setting, index) => ({
  id: index,
  ...setting,
}))
